import {
  PRODUCT_ASSORTMENT_QUERY,
  PRODUCT_BOX_SLEEVE_QUERY,
  PRODUCT_QUERY,
  PRODUCT_QUERY_BY_SLUG,
  STORE_PRODUCT_STOCK_QUERY
} from "../../../graphql/product";
import { client } from "../../utilities/config";

/**
 * Check product stock.
 *
 * @param {Int}      userCartId
 * @param {Object}   store
 *
 * @author Elizabeth Clouser <elizabeth@somepage.com>
 */
/* eslint-disable import/prefer-default-export */
export const checkStoreProductStock = (orderCode, storeId) => {
  return client.query({
    fetchPolicy: "no-cache",
    query: STORE_PRODUCT_STOCK_QUERY,
    variables: {
      storeId,
      orderCode
    }
  });
};

/**
 * Get product.
 *
 * @param {Int}      id
 *
 * @author Albert Rosa <arosa@insomniacookies.com>
 */
/* eslint-disable import/prefer-default-export */
export const getProduct = (
  id,
  redeemableId = null,
  isShowOosProducts = false
) => {
  return client.query({
    fetchPolicy: "no-cache",
    query: PRODUCT_QUERY,
    variables: {
      id,
      redeemableId,
      isShowOosProducts
    }
  });
};

/**
 * Get product.
 * @param {string}
 */
/* eslint-disable import/prefer-default-export */
export const getProductBySlug = slug => {
  return client.query({
    fetchPolicy: "no-cache",
    query: PRODUCT_QUERY_BY_SLUG,
    variables: {
      slug
    }
  });
};

export const getProductAssortment = (productId, groupIds, storeId) => {
  return client.query({
    fetchPolicy: "no-cache",
    query: PRODUCT_ASSORTMENT_QUERY,
    variables: {
      productId,
      groupIds,
      storeId
    }
  });
};

/**
 * Get product box sleeve options based on order product selections
 *
 * @param {number} orderProductId - The order product ID containing customer selections
 * @param {number} productId - The sleeve product ID (typically 279)
 * @returns {Promise} - Promise resolving to sleeve options data
 */
export const getProductBoxSleeve = (orderProductId, productId) => {
  return client.query({
    fetchPolicy: "no-cache",
    query: PRODUCT_BOX_SLEEVE_QUERY,
    variables: {
      orderProductId,
      productId
    }
  });
};
